"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/shipping/v1/cms_service.proto (package spwn.shipping.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSShippingServiceCompleteShippingResponse = exports.CMSShippingServiceCompleteShippingRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from message spwn.shipping.v1.CMSShippingServiceCompleteShippingRequest
 */
class CMSShippingServiceCompleteShippingRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string orderer_user_id = 1;
         */
        this.ordererUserId = "";
        /**
         * @generated from field: string order_id = 2;
         */
        this.orderId = "";
        /**
         * @generated from field: string carrier = 3;
         */
        this.carrier = "";
        /**
         * @generated from field: string other_carrier_name = 4;
         */
        this.otherCarrierName = "";
        /**
         * @generated from field: int32 requested_at = 5;
         */
        this.requestedAt = 0;
        /**
         * @generated from field: string tracking_number = 6;
         */
        this.trackingNumber = "";
        /**
         * @generated from field: string thanks_message = 7;
         */
        this.thanksMessage = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSShippingServiceCompleteShippingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSShippingServiceCompleteShippingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSShippingServiceCompleteShippingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSShippingServiceCompleteShippingRequest, a, b);
    }
}
exports.CMSShippingServiceCompleteShippingRequest = CMSShippingServiceCompleteShippingRequest;
CMSShippingServiceCompleteShippingRequest.runtime = protobuf_1.proto3;
CMSShippingServiceCompleteShippingRequest.typeName = "spwn.shipping.v1.CMSShippingServiceCompleteShippingRequest";
CMSShippingServiceCompleteShippingRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "orderer_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "carrier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "other_carrier_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "requested_at", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "tracking_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "thanks_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.shipping.v1.CMSShippingServiceCompleteShippingResponse
 */
class CMSShippingServiceCompleteShippingResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSShippingServiceCompleteShippingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSShippingServiceCompleteShippingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSShippingServiceCompleteShippingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSShippingServiceCompleteShippingResponse, a, b);
    }
}
exports.CMSShippingServiceCompleteShippingResponse = CMSShippingServiceCompleteShippingResponse;
CMSShippingServiceCompleteShippingResponse.runtime = protobuf_1.proto3;
CMSShippingServiceCompleteShippingResponse.typeName = "spwn.shipping.v1.CMSShippingServiceCompleteShippingResponse";
CMSShippingServiceCompleteShippingResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
//# sourceMappingURL=cms_service_pb.js.map